<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="80%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="hidden-sm-and-down" v-bind="attrs" v-on="on" color="primary" dark alt="Incluir Plano" @click="abrirCadastro()" title="Incluir Plano"><v-icon>add</v-icon>Incluir</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">
              <v-layout wrap>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model.number="qhPlano.ano" :error-messages="fieldErrors('qhPlano.ano')"
                    @blur="$v.qhPlano.ano.$touch()" label="Ano" type="number" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model.number="qhPlano.numero" :error-messages="fieldErrors('qhPlano.numero')"
                    @blur="$v.qhPlano.numero.$touch()" label="Número" type="number" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <date-picker-custom label="Data Início" :v-model="qhPlano.dataInicio" @date="qhPlano.dataInicio = $event"
                    :error-messages="fieldErrors('qhPlano.dataInicio')"></date-picker-custom>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <date-picker-custom label="Data Fim" :v-model="qhPlano.dataFim" @date="qhPlano.dataFim = $event"
                    :error-messages="fieldErrors('qhPlano.dataFim')"></date-picker-custom>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="qhPlano.descricao" :error-messages="fieldErrors('qhPlano.descricao')"
                    @blur="$v.qhPlano.descricao.$touch()" label="Descrição" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="salvar" dark>{{btnTitle}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlano from "@/model/qh/QhPlano";
import DatePickerCustom from "@/components/Custom/DatePickerCustom";
import { required, integer, maxLength } from "vuelidate/lib/validators";
import { dataFimMenor } from "@/utils/validators";
import validationMixin from "@/mixins/validationMixin";
import messageMixin from "@/mixins/message";
import EventBus from "@/utils/EventBus";
export default {
  name: "ModalCadastroQhPlano",
  components: {
    DatePickerCustom
  },
  mixins: [validationMixin, messageMixin],
  validations: {
    qhPlano: QhPlano.validations(required, integer, maxLength, dataFimMenor)
  },
  validationMessages: {
    qhPlano: QhPlano.validationMessages()
  },
  data() {
    return {
      btnTitle: "",
      dialog: false,
      formTitle: "",
      qhPlano: new QhPlano()
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    EventBus.$on("editaQhPlano", async idPlano => {
      this.formTitle = "Alterar Plano de Quadro Horário";
      this.btnTitle = "Alterar";
      this.qhPlano = await qhPlanoService.editar(idPlano);
      this.dialog = true;
    });
  },
  methods: {
    abrirCadastro() {
      this.formTitle = "Cadastrar Plano de Quadro Horário";
      this.btnTitle = "Salvar";
      this.dialog = true;
    },
    salvar() {
      this.$v.qhPlano.$touch();
      if (this.$v.$invalid) {
        return;
      }
      qhPlanoService.salvar(this.qhPlano).then(retorno => {
        if (retorno) {
          this.$emit("qhPlanoCadastrado", true);
          this.close();
        }
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
        this.qhPlano = new QhPlano();
        EventBus.$emit("resetCustom");
      }, 300);
    }
  }
};
</script>
